import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaColorPicker from "../../components/ParadigmaColorPicker/ParadigmaColorPicker.js"


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nombre: "",
            backgroundColor: "fff",
            color: "fff",
            habilitado: true,

            postVariables: ['nombre', 'backgroundColor', 'color', 'habilitado'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,
            nombre: "",
            backgroundColor: "fff",
            color: "fff",
            habilitado: true,

            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                nombre: data.nombre,
                backgroundColor: data.backgroundColor,
                color: data.color,
                habilitado: data.habilitado,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    onChangeField(field, value) {

        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            // Esto es para eliminar el cararcer "#"
            if(field==='color' || field==='backgroundColor'){
                let st=value;
                let array= st.split("#");
                prevState[field] = array[1];
            }
            else
                prevState[field] = value;
            return prevState;
        });

    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Tipo de Evento",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Tipo de Evento ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Tipo de Evento",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Tipo de Evento ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Ver Tipo de Evento",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Tipo de Evento",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Tipo de Evento ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        const {nombre, backgroundColor, color, habilitado} = this.state;
        let vars = this.modalVars();
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.calendar.tipoEventos : null)}
                submitUrl={(vars.submitType ? api.calendar.tipoEventos : null)}
                submitType={vars.submitType}
                id={vars.id}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className="ui-paradigma-modal"
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos del tipo de evento</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={50}
                                label="Nombre"
                                value={nombre}
                                onChange={(e) => this.onChangeField('nombre', e.target.value)}
                                error={() => this.getError('nombre')}
                            />
                        </div>

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Color de fondo"}
                            onChange={(e) => this.onChangeField('backgroundColor', e.target.value)}
                            error={() => this.getError('backgroundColor')}
                            inputComponent= {
                                <div className="ui-color-control">
                                    <ParadigmaColorPicker
                                        disabled= {vars.disabled}
                                        onChange={(color) => this.onChangeField('backgroundColor',color)}
                                        value={backgroundColor}
                                    />
                                </div>
                            }
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Color de texto"}
                            onChange={(e) => this.onChangeField('color', e.target.value)}
                            error={() => this.getError('color')}
                            inputComponent= {
                                <div className="ui-color-control">
                                    <ParadigmaColorPicker
                                        disabled= {vars.disabled}
                                        onChange={(color) => this.onChangeField('color',color)}
                                        value={color}
                                    />
                                </div>
                            }
                        />

                        <div className="ui-span-2">
                            <div className="ui-toggle-row">
                                <button
                                    type="button"
                                    disabled={vars.disabled}
                                    className={"ui-toggle-button" + (habilitado ? " is-active" : "")}
                                    aria-pressed={habilitado}
                                    onClick={() => this.onChangeField('habilitado', !habilitado)}
                                >
                                    <span className="ui-toggle-handle" />
                                </button>
                                <button
                                    type="button"
                                    disabled={vars.disabled}
                                    className="ui-toggle-label ui-toggle-label-button"
                                    onClick={() => this.onChangeField('habilitado', !habilitado)}
                                >
                                    Habilitado
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/TipoEventos/Modal.js